import React from 'react';
import { useParams } from 'react-router-dom';
import ApplicationTrackingView from './ApplicationTrackingView';

const ApplicationTrackingPage = () => {
    const { token } = useParams();
    return <ApplicationTrackingView token={token} />;
};

export default ApplicationTrackingPage;
